import { render, staticRenderFns } from "./BookOfAuthoritiesRspToAppealPg.vue?vue&type=template&id=638fa399&scoped=true"
import script from "./BookOfAuthoritiesRspToAppealPg.vue?vue&type=script&lang=ts"
export * from "./BookOfAuthoritiesRspToAppealPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638fa399",
  null
  
)

export default component.exports